import { __ } from '@wordpress/i18n';
import {
  PanelBody,
  RangeControl,
  SelectControl,
  ToggleControl,
} from '@wordpress/components';

export default function BehaviorPanel({ attributes, setAttributes }) {
  const {
    loop,
    autoplay,
    autoplayMode = 'step',
    autoplayDelay,
    autoScrollSpeed,
    pauseOnHover,
    showArrows,
    showDots,
  } = attributes;

  const isContinuous = autoplayMode === 'scroll';

  return (
    <PanelBody title={__('Behavior', 'brandy-blocks')} initialOpen={true}>
      <ToggleControl
        __nextHasNoMarginBottom
        label={__('Loop', 'brandy-blocks')}
        checked={!!loop}
        onChange={(value) => setAttributes({ loop: value })}
      />
      <ToggleControl
        __nextHasNoMarginBottom
        label={__('Autoplay', 'brandy-blocks')}
        checked={!!autoplay}
        onChange={(value) => setAttributes({ autoplay: value })}
      />
      {autoplay && (
        <>
          <SelectControl
            __nextHasNoMarginBottom
            label={__('Motion', 'brandy-blocks')}
            value={autoplayMode}
            options={[
              { label: __('One slide at a time', 'brandy-blocks'), value: 'step' },
              { label: __('Continuous scroll', 'brandy-blocks'), value: 'scroll' },
            ]}
            onChange={(value) => setAttributes({ autoplayMode: value })}
            help={
              isContinuous
                ? __(
                    'Slides drift without stopping. Turn on Loop so the strip has no end to reach.',
                    'brandy-blocks'
                  )
                : __('Slides advance on a timer and settle between steps.', 'brandy-blocks')
            }
          />
          {isContinuous ? (
            <RangeControl
              label={__('Scroll speed', 'brandy-blocks')}
              value={autoScrollSpeed}
              min={0.5}
              max={6}
              step={0.25}
              onChange={(value) => setAttributes({ autoScrollSpeed: value })}
              help={__('Pixels per frame. Around 1 reads as a slow drift.', 'brandy-blocks')}
            />
          ) : (
            <RangeControl
              label={__('Autoplay delay (ms)', 'brandy-blocks')}
              value={autoplayDelay}
              min={1000}
              max={10000}
              step={500}
              onChange={(value) => setAttributes({ autoplayDelay: value })}
            />
          )}
          <ToggleControl
            __nextHasNoMarginBottom
            label={__('Pause on hover', 'brandy-blocks')}
            checked={!!pauseOnHover}
            onChange={(value) => setAttributes({ pauseOnHover: value })}
          />
        </>
      )}
      <ToggleControl
        __nextHasNoMarginBottom
        label={__('Show arrows', 'brandy-blocks')}
        checked={!!showArrows}
        onChange={(value) => setAttributes({ showArrows: value })}
      />
      <ToggleControl
        __nextHasNoMarginBottom
        label={__('Show dots', 'brandy-blocks')}
        checked={!!showDots}
        onChange={(value) => setAttributes({ showDots: value })}
      />
    </PanelBody>
  );
}
